export enum importProjectModalEvents {
    SHOW_IMPORT_PROJECT = 'importProjectModal/show',
    HIDE_IMPORT_PROJECT = 'importProjectModal/hide',
}

const showImportProjectModal = (options = {}) => {
    const event = new CustomEvent(importProjectModalEvents.SHOW_IMPORT_PROJECT, {
        detail: options,
    });
    window.dispatchEvent(event);
};

const hideImportProjectModal = () => {
    window.dispatchEvent(new CustomEvent(importProjectModalEvents.HIDE_IMPORT_PROJECT));
};

export default {
    showImportProjectModal,
    hideImportProjectModal,
};
